
import { defineComponent } from 'vue'
import Activity from '@/components/Activity.vue' // @ is an alias to /src

export default defineComponent({
  name: 'Home',
  components: {
    Activity
  }
})
